enum EnvironmentStatus {
  PENDING = "pending",
  RUNNING = "running",
  STOPPING = "stopping",
  STOPPED = "stopped",
  FAILED = "failed",
}

export default EnvironmentStatus;
